import React from "react";
import { useNavigate } from "react-router-dom";

const BlockedOverlay = ({ isBlocked, essaysRemaining }) => {
  const navigate = useNavigate();

  const handlePaymentClick = () => {
    navigate("/plans-management");
  };

  return (
    <div className="absolute inset-0 bg-white/60 backdrop-blur-sm z-10 flex flex-col items-center justify-center">
      <div className="mb-4">
        <svg
          className="w-16 h-16 text-red-500"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            fillRule="evenodd"
            d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z"
            clipRule="evenodd"
          />
        </svg>
      </div>

      <div className="text-center">
        {isBlocked ? (
          <>
            <p className="text-gray-800 font-medium text-lg">
              Blocked by admin
            </p>
          </>
        ) : essaysRemaining <= 0 ? (
          <>
            <p className="text-gray-800 font-medium text-lg mb-4">
              You have no essays remaining. Please buy a plan to continue.
            </p>
            <button
              onClick={handlePaymentClick}
              className="px-6 py-2 bg-red-600 text-white font-semibold rounded-lg shadow hover:bg-red-700 transition"
            >
              Go to Plans
            </button>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default BlockedOverlay;
